import { Button, Flex, Typography } from "antd"

export const SettingsAutoConversionStepUi = () => {
  return (
    <Typography.Text>
      If you plan to use the cryptocurrency payment service, this section allows
      you to choose the currency in which all incoming payments will be
      automatically converted at the time of receipt. You can also set up
      automatic conversion for specific cryptocurrencies individually
      <br />
      By default, the auto-conversion option is set to USDT TRC20
    </Typography.Text>
  )
}
